import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: theme.spacing(65.625),
    height: theme.spacing(32.5),
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      minWidth: 0,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  formControl: {
    position: 'relative',
    marginTop: theme.spacing(1.5),
  },
  actionButton: {
    margin: theme.spacing(3),
    height: theme.spacing(5.25),
    width: theme.spacing(16),
  },
  printButton: {
    marginLeft: theme.spacing(2),
    height: theme.spacing(5.25),
    width: theme.spacing(16),
    backgroundColor: '#fc6161',
    color: '#fff',
  },
  select: {
    borderRadius: '0px',
    width: '255px',
  },
  blueMenu: {
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    marginBottom: '0px !important',
    width: '525px',
    height: '60px',
  },
  menuButton: {
    marginLeft: theme.spacing(27),
    marginRight: theme.spacing(1),
    color: theme.palette.secondary.contrastText,
    lineHeight: '2.6',
  },
}));

const PRINT_CARDHOLDER = gql`
  mutation printCard($cardholderId: Int!, $cardNumber: Int!, $printQueueId: Int!) {
    printCard(cardholderId: $cardholderId, cardNumber: $cardNumber, printQueueId: $printQueueId)
  }
`;

const CardPrint = ({ visible, card, dismiss, match, printers, cardholderId }) => {
  const classes = useStyles();
  const [printerId, setPrinterId] = useState();
  const modalTitle = 'Print Card';

  const handleChange = (event) => {
    setPrinterId(event.target.value);
  };

  const [printCardholder] = useMutation(PRINT_CARDHOLDER);
  return (
    <Modal
      className={classes.modal}
      open={visible}
      onClose={() => {
        dismiss();
      }}
    >
      <div className={classes.paper}>
        <div className={classes.blueMenu}>
          <Typography variant="h6" className={classes.menuButton}>
            {modalTitle}
          </Typography>
        </div>
        <span>
          <Typography variant="body1" style={{ marginTop: '21px' }}>
            Select a printer to print your card
          </Typography>
        </span>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">Printer</InputLabel>
          <Select
            className={classes.select}
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            onChange={handleChange}
            label="Printer"
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {printers.map((item) => (
              <MenuItem value={item.printQueueId}>{item.printerName}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div>
          <Button
            className={classes.printButton}
            variant="contained"
            style={{ backgroundColor: '#5ba9e1', color: '#fff', margin: '0px 81px 0px 48px' }}
            onClick={() => {
              console.log(card, 'card info');
              const printPayload = {
                cardholderId,
                cardNumber: card.cardNumber,
                printQueueId: printerId,
              };
              printCardholder({ variables: printPayload }).then((res) => {
                console.log(res, 'after print response');
                dismiss();
              });
            }}
          >
            Print
          </Button>
          <Button
            className={classes.actionButton}
            onClick={() => {
              dismiss();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CardPrint;
